import {
    Box,
    Typography,
    Card,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material"
import {
    // Close,
    // DownloadDoneOutlined,
    ExpandMoreOutlined,
    // DownloadOutlined,
    // Edit,
    // DeleteOutline
} from "@mui/icons-material"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import { useNavigate } from "react-router-dom"
import { Loader } from "../components/index"
import { GetCurrentUser } from "../utils/hooks"
import { useLazyGetInstitutionClassesQuery } from "../Redux/actions/classSetup.action"
import { useLazyGetInstitutionMetadataQuery, useLazyGetUserInstitutionQuery } from "../Redux/actions/setting.action"
import {
    useDownloadTimetableMutation
} from "../Redux/actions/download.action"
import {
    useLazyGetAllExamsTimetableQuery,
    useDeleteExaminationMutation,
    useEditExaminationNameMutation
} from "../Redux/actions/examAction"
import ExamListSummary from "./examSummary"
import _ from "lodash"
import React from "react"
import { Message, toaster } from "rsuite"

export default function ManageExamsPage() {
    const navigate = useNavigate()
    // const theme = useTheme()
    // const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    // const [selectedSubjectInfo, setSelectedSubjectInfo] = React.useState(null)
    // const [openManage, setOpenManage] = React.useState(false)



    const [getClassesAction, getClassesState] = useLazyGetInstitutionClassesQuery()
    const [getInstitutionMetadataAction, getInstitutionMetadataState] = useLazyGetInstitutionMetadataQuery()
    const [getInstitutionAction, getInstitutionState] = useLazyGetUserInstitutionQuery()
    const [downloadTimetableAction, downloadTimetableState] = useDownloadTimetableMutation()
    const [getAllExamTimetable, getAllExamTimetableState] = useLazyGetAllExamsTimetableQuery()
    const [deleteExamination,deleteExaminationState] = useDeleteExaminationMutation()
    const [editExamination,editExaminationState] = useEditExaminationNameMutation()

    React.useEffect(() => {
        fetchPlatformData()
        return () => {
            downloadTimetableState.reset()
        }
    }, [])

    React.useEffect(()=> {
        if(editExaminationState.isSuccess){
            const message = _.get(editExaminationState,"data.message","")
            toaster.push(<Message type="success">{message}</Message>,{placement:"topCenter"})
            editExaminationState.reset()
            fetchPlatformData()
        }else if (editExaminationState.isError){
            toaster.push(<Message type="success" >Error while edit the examination!</Message>,{placement:"topCenter"})
            editExaminationState.reset()
        }
    },[editExaminationState.status])
    React.useEffect(()=>{
        if(deleteExaminationState.status === "fulfilled" && deleteExaminationState.isSuccess){
            const message = _.get(deleteExaminationState,"data.message","")
            toaster.push(<Message type="success">{message}</Message>,{placement:"topCenter"})
            deleteExaminationState.reset()
            fetchPlatformData()
        }else if(deleteExaminationState.isError){
            toaster.push(<Message type="success" >Error while delete the examination!</Message>,{placement:"topCenter"})
            deleteExaminationState.reset()
        }
    },[deleteExaminationState.status])

    React.useEffect(() => {
        const downloadTimetable = async () => {
            if (downloadTimetableState.status === "fulfilled") {
                const blob = downloadTimetableState.data
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = url
                a.download = "timetable.pdf"
                document.body.appendChild(a)
                a.click()
                a.remove()
                window.URL.revokeObjectURL(url)
                downloadTimetableState.reset()
            }
        }
        downloadTimetable()
    }, [downloadTimetableState.status])

    function fetchPlatformData() {
        const user = GetCurrentUser()
        if (user) {
            let user_platform = _.get(user, "meta_data.user_platform", null)
            user_platform && getClassesAction({ institution_ref: user_platform })
            user_platform && getInstitutionAction(user_platform)
            user_platform && getInstitutionMetadataAction(user_platform)
            user_platform && getAllExamTimetable({ school_id: user_platform })
        }
    }

    const classes = React.useMemo(() => {
        if (getClassesState.isSuccess) {
            let list = _.get(getClassesState, "currentData.list", null);
            return list
        } else {
            return null
        }
    }, [getClassesState])
    const examsTimetableList = React.useMemo(() => {
        if (getAllExamTimetableState.isSuccess) {
            const list = _.get(getAllExamTimetableState, "currentData", [])
            return list
        } else {
            return []
        }
    }, [getAllExamTimetableState])
    

    const institutionInfo = React.useMemo(() => {
        if (getInstitutionState.isSuccess) {
            const data = _.get(getInstitutionState, "currentData.data", null)
            if (data) {
                return {
                    "name": _.get(data, "name", ""),
                    "address": `${_.get(data, "state")} ${_.get(data, "district", "")} ${_.get(data, "pin", "")} ${_.get(data, "address", "")}`
                }
            } else {
                return null
            }
        } else {
            return null
        }
    }, [getInstitutionState.currentData])

    function handleDeleteExam(id){
        if(!id) return
        deleteExamination({
            id:id
        })
    }
    function handleEditExamination(id,exam_name){
        if(!id || !exam_name) return
        editExamination({
            id,
            exam_name
        })
    }



    return (
        <div className="col-md-12"
            style={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #512DA8, #673AB7, #9575CD)",
                p: { xs: 2, sm: 4 },
            }}
        >
            <Card
                sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    p: { xs: 2, sm: 4 },
                    borderRadius: 4,
                    bgcolor: "#ffffffee",
                    backdropFilter: "blur(12px)",
                }}
            >
                {/* ---------- HEADER ---------- */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: 2,
                        mb: 3,
                    }}
                >
                    <Typography variant="h4" fontWeight="bold" textAlign="center">
                        Manage Exams
                    </Typography>

                    <Button
                        fullWidth={{ xs: true, sm: false }}
                        variant="contained"
                        startIcon={<AddCircleOutlineIcon />}
                        sx={{
                            bgcolor: "#4CAF50",
                            "&:hover": { bgcolor: "#45A049" },
                            py: 1.4,
                        }}
                        onClick={() => navigate("/exam/create")}
                    >
                        Create New Exam
                    </Button>
                </Box>

                <Typography sx={{ opacity: 0.7, mb: 4, textAlign: "center" }}>
                    Update, publish, and review previously created exams.
                </Typography>

                {/* -------- ACCORDION LIST -------- */}
                {Array.isArray(classes) &&
                    classes.length > 0 &&
                    classes.map((item, index) => {
                        let className = _.get(item, "class_name", "")
                        let classId = _.get(item, "id", null)
                        const findTimetableItem = Array.isArray(examsTimetableList) & examsTimetableList.length > 0 && examsTimetableList.filter(i => i.class_ref === classId)

                        return (
                            <Accordion key={index} sx={{ mb: 2, borderRadius: 2 }}>
                                <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
                                    <Typography fontSize="18px" fontWeight={600}>
                                        {className}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    {Array.isArray(findTimetableItem) && findTimetableItem.length > 0 ? (
                                        <ExamListSummary
                                            examData={findTimetableItem}
                                            onDownloadTimetable={(tTable, class_ref, school_ref, exam_name,id) => {
                                                if (!institutionInfo) return
                                                if (!Array.isArray(classes) || !class_ref) return
                                                const findClass = classes.find(cl => cl.id === class_ref)
                                                if(!findClass) return
                                                console.log({findClass})
                                                const data = {
                                                    ...institutionInfo,
                                                    "className": findClass.class_name,
                                                    "examName": exam_name.toUpperCase(),
                                                    "timeTable": [...tTable],
                                                    "exam_id":id,
                                                    "school_ref":findClass.institution_ref
                                                }
                                                downloadTimetableAction(data)
                                            }}
                                            handleDeleteExam={handleDeleteExam}
                                            handleEditExamination={handleEditExamination}
                                        />
                                    ) : (
                                        <Typography
                                            sx={{
                                                fontSize: "18px",
                                                textAlign: "center",
                                                py: 2,
                                                opacity: 0.6,
                                            }}
                                        >
                                            No exams created yet.
                                        </Typography>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        )
                    })}
            </Card>
            {
                (
                    getClassesState.isLoading ||
                    getInstitutionMetadataState.isLoading ||
                    getInstitutionState.isLoading ||
                    downloadTimetableState.isLoading ||
                    getAllExamTimetableState.isLoading ||
                    deleteExaminationState.isLoading ||
                    editExaminationState.isLoading
                ) && <Loader show={true} />}
        </div>
    );
}
